export const projectData = {
    'the-unknown-soldier': {
        title: "The Unknown Soldier",
        role: "Lead Producer, 1st AD",
        lengthAndYear:"12 min, 2025",
        videoLink: "https://www.youtube.com/watch?v=QsNFh94cYjE&t=1s",
        intro: "This is definitely the most complex project I have done so far. Despite the immense pressure and many seemly unsolvable hurdles coming along, I'm so proud we made the first half of the film done with just 3 weeks preproduction!",
        storyUrl: ''
    },
    'ivd-ivw': {
        title: "I've Been Dreaming, \nI've Been Working",
        role: "Lead Producer",
        lengthAndYear: "7 min, 2023",
        intro: `This is my second time participating the 48 hour film competition as a producer. It's kinda unreal that we accomplished a musical short film within just 2 days! \n
View the movie here (still in festival circulation):  https://t.ly/2qk11
        `,
        storyUrl: 'musical'
    },
    'for-petes-sake': {
        title: "For Pete's Sake",
        role: "Director, Producer",
        lengthAndYear: "8 min, 2023",
        videoLink: "https://vimeo.com/862226320",
        intro: `For Pete’s Sake is a coming-of-age drama about a boy (LEE) who struggles to defeat his father in an arm wrestling match as he grows up. But when LEE finally achieves victory over his father, he realizes the bittersweet reality of his father’s dismissing strength.

Moreover, This is a story that's based on real life events. The original story is written by Thomas Brodkin, who wrote the story based on his memory with his dad. I saw the story on an online writers' forum called Reedsy and I reached out to him for the permssion to adapt it to a short film.

View the final film here: https://t.ly/6sXfY`,
        storyUrl: 'for-petes-sake'
    },
    'lolas-recipe':{
        title: "Lola's Recipe",
        role: "Producer",
        lengthAndYear: "3 min, 2023",
        videoLink: "https://youtu.be/3MF6fmGeJRg",
        intro: `A mother has to find the courage to tell her little daughter the passing of the grandma. What connects the family in the end is the beloved bakery recipe the grandma left. As the story is set in the filipino culture, Lola means exactly "grandma" in Tagalog. 

This is a simple 3-minute short film as part of the #YODOContest, in which we proudly won the first place!`,
        storyUrl: 'toronto'
    },
    'a-few-more': {
        title: "A Few More",
        role: "Producer",
        lengthAndYear: "7 min, 2022",
        videoLink: "https://youtu.be/lPwTspQ7Gak",
        intro: `A Few More is a film made within 48 hours, from writing to editing. This was my first time participating in the 48 Hour Film Project in Toronto, and it marked the beginning of many more projects after.`,
        storyUrl: 'toronto'
    },
    'latte-art': {
        title: "Latte Art",
        role: "Director, Producer, Writer & Editor",
        lengthAndYear: "15 min, 2021",
        videoLink: "https://vimeo.com/737726161",
        intro: `Latte art is my second short film. Making it was a very tough journey from which I learnt awful a LOT!`,
        storyUrl: 'second-short-film'
    },
    'sleepiness': {
        title: "困 (Sleepiness)",
        role: "Director, Producer, Writer & Editor",
        lengthAndYear:"20 min, 2015",
        videoLink: "https://youtu.be/qBHwhgx487g",
        intro: "This is my first short film ever made, back in high school.",
        storyUrl: 'the-beginning'
    }
}